<template>
  <div class="vertical-center">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1920 1080"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g class="clickable" @click="onClick" id="main-btn">
        <g filter="url(#filter2_d)">
          <rect
            x="685"
            y="879"
            width="549"
            height="126"
            rx="42"
            v-bind:fill="isRunning ? theme.minor : theme.base"
          />
          <rect
            x="688.5"
            y="882.5"
            width="542"
            height="119"
            rx="38.5"
            v-bind:stroke="isRunning ? theme.base : theme.major"
            stroke-width="7"
          />
        </g>
        <g filter="url(#filter3_d)">
          <path
            v-bind:d="mainBtn"
            v-bind:fill="isRunning ? theme.base : theme.minor"
          />
        </g>
      </g>
      <g id="cluster">
        <path
          d="M1406 185H1467V221H1406V185Z"
          v-bind:fill="theme.major"
          v-bind:stroke="theme.minor"
          stroke-width="4"
        />
        <rect
          x="929"
          y="185"
          width="61"
          height="36"
          v-bind:fill="theme.major"
          v-bind:stroke="theme.minor"
          stroke-width="4"
        />
        <rect
          x="452"
          y="185"
          width="61"
          height="36"
          v-bind:fill="theme.major"
          v-bind:stroke="theme.minor"
          stroke-width="4"
        />
        <rect
          x="1374"
          y="215"
          width="125"
          height="60"
          v-bind:fill="theme.major"
          v-bind:stroke="theme.minor"
          stroke-width="4"
        />
        <rect
          x="897"
          y="215"
          width="125"
          height="60"
          v-bind:fill="theme.major"
          v-bind:stroke="theme.minor"
          stroke-width="4"
        />
        <rect
          x="420"
          y="215"
          width="125"
          height="60"
          v-bind:fill="theme.major"
          v-bind:stroke="theme.minor"
          stroke-width="4"
        />
        <g filter="url(#filter4_d)">
          <rect
            x="177"
            y="269"
            width="1566"
            height="530"
            rx="127"
            v-bind:fill="theme.major"
          />
          <rect
            x="180.5"
            y="272.5"
            width="1559"
            height="523"
            rx="123.5"
            v-bind:stroke="theme.minor"
            stroke-width="7"
          />
        </g>
        <g filter="url(#filter5_d)">
          <circle cx="1437" cy="534" r="200" v-bind:fill="theme.base" />
          <circle
            cx="1437"
            cy="534"
            r="198"
            v-bind:stroke="theme.minor"
            stroke-width="4"
          />
        </g>
        <g filter="url(#filter6_d)">
          <circle cx="960" cy="534" r="200" v-bind:fill="theme.base" />
          <circle
            cx="960"
            cy="534"
            r="198"
            v-bind:stroke="theme.minor"
            stroke-width="4"
          />
        </g>
        <g filter="url(#filter7_d)">
          <circle cx="483" cy="534" r="200" v-bind:fill="theme.base" />
          <circle
            cx="483"
            cy="534"
            r="198"
            v-bind:stroke="theme.minor"
            stroke-width="4"
          />
        </g>
        <path
          d="M1478.58 638.439C1479.37 638.672 1480.21 638.217 1480.44 637.422L1484.24 624.467C1484.47 623.672 1484.01 622.839 1483.22 622.606C1482.42 622.373 1481.59 622.828 1481.36 623.623L1477.98 635.139L1466.47 631.763C1465.67 631.53 1464.84 631.986 1464.61 632.781C1464.37 633.576 1464.83 634.409 1465.62 634.642L1478.58 638.439ZM1436.68 562.72L1477.68 637.72L1480.32 636.28L1439.32 561.28L1436.68 562.72Z"
          v-bind:fill="theme.major"
        />
        <path
          d="M1438.06 396.939C1437.47 396.354 1436.53 396.354 1435.94 396.939L1426.39 406.485C1425.81 407.071 1425.81 408.021 1426.39 408.607C1426.98 409.192 1427.93 409.192 1428.51 408.607L1437 400.121L1445.49 408.607C1446.07 409.192 1447.02 409.192 1447.61 408.607C1448.19 408.021 1448.19 407.071 1447.61 406.485L1438.06 396.939ZM1438.5 562V398H1435.5V562H1438.5Z"
          v-bind:fill="theme.major"
        />
        <path
          d="M1001.58 635.439C1002.37 635.672 1003.21 635.217 1003.44 634.422L1007.24 621.467C1007.47 620.672 1007.01 619.839 1006.22 619.606C1005.42 619.373 1004.59 619.828 1004.36 620.623L1000.98 632.139L989.467 628.763C988.672 628.53 987.839 628.986 987.606 629.781C987.373 630.576 987.828 631.409 988.623 631.642L1001.58 635.439ZM959.684 559.72L1000.68 634.72L1003.32 633.28L962.316 558.28L959.684 559.72Z"
          v-bind:fill="theme.major"
        />
        <path
          d="M961.061 393.939C960.475 393.354 959.525 393.354 958.939 393.939L949.393 403.485C948.808 404.071 948.808 405.021 949.393 405.607C949.979 406.192 950.929 406.192 951.515 405.607L960 397.121L968.485 405.607C969.071 406.192 970.021 406.192 970.607 405.607C971.192 405.021 971.192 404.071 970.607 403.485L961.061 393.939ZM961.5 559V395H958.5V559H961.5Z"
          v-bind:fill="theme.major"
        />
        <path
          d="M524.578 635.439C525.373 635.672 526.206 635.217 526.439 634.422L530.237 621.467C530.47 620.672 530.014 619.839 529.219 619.606C528.424 619.373 527.591 619.828 527.358 620.623L523.982 632.139L512.467 628.763C511.672 628.53 510.839 628.986 510.606 629.781C510.373 630.576 510.828 631.409 511.623 631.642L524.578 635.439ZM482.684 559.72L523.684 634.72L526.316 633.28L485.316 558.28L482.684 559.72Z"
          v-bind:fill="theme.major"
        />
        <path
          d="M484.061 393.939C483.475 393.354 482.525 393.354 481.939 393.939L472.393 403.485C471.808 404.071 471.808 405.021 472.393 405.607C472.979 406.192 473.929 406.192 474.515 405.607L483 397.121L491.485 405.607C492.071 406.192 493.021 406.192 493.607 405.607C494.192 405.021 494.192 404.071 493.607 403.485L484.061 393.939ZM484.5 559V395H481.5V559H484.5Z"
          v-bind:fill="theme.major"
        />
        <g filter="url(#filter8_d)">
          <path v-bind:d="rightTimer.path" v-bind:fill="theme.minor" />
        </g>
        <g filter="url(#filter9_d)">
          <path v-bind:d="middleTimer.path" v-bind:fill="theme.minor" />
        </g>
        <g filter="url(#filter10_d)">
          <path v-bind:d="leftTimer.path" v-bind:fill="theme.minor" />
        </g>
      </g>
      <g class="clickable" @click="onClickSettings" id="settings-btn">
        <g filter="url(#filter0_d)">
          <rect
            x="1601"
            y="75"
            width="241"
            height="75"
            rx="26"
            v-bind:fill="settingsClicked ? theme.minor : theme.base"
          />
          <rect
            x="1604.5"
            y="78.5"
            width="234"
            height="68"
            rx="22.5"
            v-bind:stroke="settingsClicked ? theme.base : theme.major"
            stroke-width="7"
          />
        </g>
        <g filter="url(#filter1_d)">
          <path
            d="M1649.47 121.112L1651.94 118.52H1657.87L1660.19 121.112H1649.47ZM1660.96 120.056L1658.37 117.584V111.68L1660.96 109.328V120.056ZM1651.53 110.192C1650.97 109.744 1650.4 109.304 1649.83 108.872L1651.53 107.6H1658.08L1659.76 108.872L1658.08 110.192H1651.53ZM1649.44 96.728H1660.17L1657.79 99.32H1651.91L1649.44 96.728ZM1648.67 108.488V97.76L1651.27 100.088V106.04L1648.67 108.488ZM1669.02 121.112L1671.49 118.52H1677.42L1679.77 121.112H1669.02ZM1668.33 109.328L1670.89 111.824V117.704L1668.33 120.056V109.328ZM1671.09 110.192C1670.49 109.728 1669.93 109.288 1669.41 108.872L1671.09 107.6H1677.64L1679.32 108.872L1677.64 110.192H1671.09ZM1669 96.728H1679.7L1677.37 99.32H1671.45L1669 96.728ZM1668.25 108.488V97.76L1670.82 100.088V106.04L1668.25 108.488ZM1694.53 120.056L1691.94 117.584V111.68L1694.53 109.328V120.056ZM1685.84 98.888C1685.28 98.44 1684.72 98.016 1684.16 97.616L1685.84 96.32H1700.58L1702.26 97.616L1700.58 98.888H1694.46V108.488L1691.87 106.16V100.232L1693.28 98.888H1685.84ZM1713.72 120.056L1711.13 117.584V111.68L1713.72 109.328V120.056ZM1705.04 98.888C1704.48 98.44 1703.92 98.016 1703.36 97.616L1705.04 96.32H1719.77L1721.45 97.616L1719.77 98.888H1713.65V108.488L1711.06 106.16V100.232L1712.48 98.888H1705.04ZM1732.92 120.056L1730.33 117.584V111.68L1732.92 109.328V120.056ZM1732.87 97.76V108.488L1730.28 106.16V100.232L1732.87 97.76ZM1743.52 107.288V96.512L1746.12 98.888V104.816L1743.52 107.288ZM1758.14 96.512V107.288L1755.55 104.912V99.008L1758.14 96.512ZM1743.45 108.104L1746.04 110.576V116.504L1743.45 118.856V108.104ZM1758.07 118.856L1755.48 116.36V110.456L1758.07 108.104V118.856ZM1747.34 103.616V98.744L1754.16 110.216V115.112L1747.34 103.616ZM1764.64 121.112L1767.11 118.52H1773.04L1775.37 121.112H1764.64ZM1763.92 109.328L1766.51 111.824V117.704L1763.92 120.056V109.328ZM1776.13 120.056L1773.54 117.584V111.68L1776.13 109.328V120.056ZM1766.7 110.192C1766.14 109.744 1765.57 109.304 1765 108.872L1766.7 107.6H1773.25L1774.93 108.872L1773.25 110.192H1766.7ZM1764.61 96.728H1775.34L1772.97 99.32H1767.09L1764.61 96.728ZM1763.85 108.488V97.76L1766.44 100.088V106.04L1763.85 108.488ZM1783.83 121.112L1786.31 118.52H1792.23L1794.56 121.112H1783.83ZM1795.33 120.056L1792.74 117.584V111.68L1795.33 109.328V120.056ZM1785.9 110.192C1785.34 109.744 1784.77 109.304 1784.19 108.872L1785.9 107.6H1792.45L1794.13 108.872L1792.45 110.192H1785.9ZM1783.81 96.728H1794.54L1792.16 99.32H1786.28L1783.81 96.728ZM1783.04 108.488V97.76L1785.63 100.088V106.04L1783.04 108.488Z"
            v-bind:fill="settingsClicked ? theme.base : theme.minor"
          />
        </g>
      </g>
      <g class="clickable" v-if="settingsClicked" id="settings-dropdown">
        <g @click="onClickSettings" id="cancel-btn">
          <g filter="url(#filter11_d)">
            <rect
              x="1578"
              y="327"
              width="255"
              height="48"
              v-bind:fill="theme.minor"
            />
            <rect
              x="1580.5"
              y="329.5"
              width="250"
              height="43"
              v-bind:stroke="theme.major"
              stroke-width="5"
            />
          </g>
          <g filter="url(#filter12_d)">
            <path
              d="M1669.77 357.834L1671.62 355.89H1676.07L1677.83 357.834H1669.77ZM1669.24 348.996L1671.17 350.868V355.278L1669.24 357.042V348.996ZM1669.75 339.546H1677.78L1676.03 341.49H1671.58L1669.75 339.546ZM1669.19 348.366V340.32L1671.12 342.066V346.53L1669.19 348.366ZM1683.35 348.996L1685.3 350.868V355.278L1683.35 357.042V348.996ZM1692.52 357.042L1690.57 355.188V350.76L1692.52 348.996V357.042ZM1685.44 349.644C1685.02 349.308 1684.6 348.978 1684.16 348.654L1685.44 347.7H1690.36L1691.62 348.654L1690.36 349.644H1685.44ZM1683.88 339.546H1691.92L1690.14 341.49H1685.73L1683.88 339.546ZM1683.3 348.366V340.32L1685.24 342.066V346.53L1683.3 348.366ZM1692.46 340.32V348.366L1690.52 346.62V342.174L1692.46 340.32ZM1696.85 347.466V339.384L1698.79 341.166V345.612L1696.85 347.466ZM1707.81 339.384V347.466L1705.87 345.684V341.256L1707.81 339.384ZM1696.8 348.078L1698.74 349.932V354.378L1696.8 356.142V348.078ZM1707.76 356.142L1705.81 354.27V349.842L1707.76 348.078V356.142ZM1699.71 344.712V341.058L1704.82 349.662V353.334L1699.71 344.712ZM1712.96 357.834L1714.81 355.89H1719.26L1721.02 357.834H1712.96ZM1712.43 348.996L1714.36 350.868V355.278L1712.43 357.042V348.996ZM1712.94 339.546H1720.97L1719.22 341.49H1714.77L1712.94 339.546ZM1712.38 348.366V340.32L1714.31 342.066V346.53L1712.38 348.366ZM1727.35 357.834L1729.21 355.89H1733.65L1735.42 357.834H1727.35ZM1726.83 348.996L1728.76 350.868V355.278L1726.83 357.042V348.996ZM1728.9 349.644C1728.46 349.296 1728.04 348.966 1727.64 348.654L1728.9 347.7H1733.81L1735.07 348.654L1733.81 349.644H1728.9ZM1727.33 339.546H1735.36L1733.62 341.49H1729.17L1727.33 339.546ZM1726.78 348.366V340.32L1728.7 342.066V346.53L1726.78 348.366ZM1741.75 357.834L1743.6 355.89H1748.05L1749.81 357.834H1741.75ZM1741.23 348.996L1743.15 350.868V355.278L1741.23 357.042V348.996ZM1741.17 348.366V340.32L1743.1 342.066V346.53L1741.17 348.366Z"
              v-bind:fill="theme.base"
            />
          </g>
        </g>
        <g @click="onClickColorChange" id="color-change-btn">
          <g filter="url(#filter13_d)">
            <rect
              x="1578"
              y="282"
              width="255"
              height="48"
              v-bind:fill="theme.base"
            />
            <rect
              x="1580.5"
              y="284.5"
              width="250"
              height="43"
              v-bind:stroke="theme.major"
              stroke-width="5"
            />
          </g>
          <g filter="url(#filter14_d)">
            <path
              d="M1626.58 314.834L1628.43 312.89H1632.88L1634.64 314.834H1626.58ZM1626.06 305.996L1627.98 307.868V312.278L1626.06 314.042V305.996ZM1626.56 296.546H1634.59L1632.84 298.49H1628.4L1626.56 296.546ZM1626 305.366V297.32L1627.93 299.066V303.53L1626 305.366ZM1640.16 305.996L1642.11 307.868V312.278L1640.16 314.042V305.996ZM1649.33 314.042L1647.38 312.188V307.76L1649.33 305.996V314.042ZM1642.25 306.644C1641.83 306.308 1641.41 305.978 1640.97 305.654L1642.25 304.7H1647.17L1648.43 305.654L1647.17 306.644H1642.25ZM1640.11 305.366V297.32L1642.05 299.066V303.53L1640.11 305.366ZM1649.27 297.32V305.366L1647.33 303.62V299.174L1649.27 297.32ZM1654.56 305.996L1656.5 307.868V312.278L1654.56 314.042V305.996ZM1663.72 314.042L1661.78 312.188V307.76L1663.72 305.996V314.042ZM1656.65 306.644C1656.23 306.308 1655.8 305.978 1655.37 305.654L1656.65 304.7H1661.56L1662.82 305.654L1661.56 306.644H1656.65ZM1655.08 296.546H1663.13L1661.35 298.49H1656.94L1655.08 296.546ZM1654.51 305.366V297.32L1656.45 299.066V303.53L1654.51 305.366ZM1663.67 297.32V305.366L1661.72 303.62V299.174L1663.67 297.32ZM1668.06 304.466V296.384L1670 298.166V302.612L1668.06 304.466ZM1679.02 296.384V304.466L1677.07 302.684V298.256L1679.02 296.384ZM1668 305.078L1669.95 306.932V311.378L1668 313.142V305.078ZM1678.96 313.142L1677.02 311.27V306.842L1678.96 305.078V313.142ZM1670.92 301.712V298.058L1676.03 306.662V310.334L1670.92 301.712ZM1683.89 314.834L1685.75 312.89H1690.19L1691.94 314.834H1683.89ZM1683.35 305.996L1685.3 307.868V312.278L1683.35 314.042V305.996ZM1692.52 314.042L1690.57 312.188V307.76L1692.52 305.996V314.042ZM1685.44 306.644C1685.02 306.308 1684.6 305.978 1684.16 305.654L1685.44 304.7H1690.36L1691.62 305.654L1690.36 306.644H1685.44ZM1683.88 296.546H1691.92L1690.14 298.49H1685.73L1683.88 296.546ZM1683.3 305.366V297.32L1685.24 299.066V303.53L1683.3 305.366ZM1698.56 314.834L1700.41 312.89H1704.86L1706.62 314.834H1698.56ZM1698.04 305.996L1699.96 307.868V312.278L1698.04 314.042V305.996ZM1700.11 306.644C1699.66 306.296 1699.24 305.966 1698.85 305.654L1700.11 304.7H1705.02L1706.28 305.654L1705.02 306.644H1700.11ZM1698.54 296.546H1706.57L1704.82 298.49H1700.38L1698.54 296.546ZM1697.98 305.366V297.32L1699.91 299.066V303.53L1697.98 305.366ZM1727.35 314.834L1729.21 312.89H1733.65L1735.42 314.834H1727.35ZM1726.83 305.996L1728.76 307.868V312.278L1726.83 314.042V305.996ZM1727.33 296.546H1735.36L1733.62 298.49H1729.17L1727.33 296.546ZM1726.78 305.366V297.32L1728.7 299.066V303.53L1726.78 305.366ZM1741.48 314.834L1743.33 312.89H1747.78L1749.52 314.834H1741.48ZM1740.94 305.996L1742.88 307.868V312.278L1740.94 314.042V305.996ZM1750.1 314.042L1748.16 312.188V307.76L1750.1 305.996V314.042ZM1741.46 296.546H1749.51L1747.72 298.49H1743.31L1741.46 296.546ZM1740.88 305.366V297.32L1742.83 299.066V303.53L1740.88 305.366ZM1750.05 297.32V305.366L1748.1 303.62V299.174L1750.05 297.32ZM1756.15 314.834L1758 312.89H1762.45L1764.21 314.834H1756.15ZM1755.62 305.996L1757.55 307.868V312.278L1755.62 314.042V305.996ZM1755.57 305.366V297.32L1757.5 299.066V303.53L1755.57 305.366ZM1770.27 314.834L1772.13 312.89H1776.57L1778.32 314.834H1770.27ZM1769.73 305.996L1771.68 307.868V312.278L1769.73 314.042V305.996ZM1778.89 314.042L1776.95 312.188V307.76L1778.89 305.996V314.042ZM1770.25 296.546H1778.3L1776.52 298.49H1772.11L1770.25 296.546ZM1769.68 305.366V297.32L1771.62 299.066V303.53L1769.68 305.366ZM1778.84 297.32V305.366L1776.9 303.62V299.174L1778.84 297.32ZM1786.09 308.3V312.278L1784.15 314.042V305.996L1786.09 308.3ZM1790.1 307.832L1792.88 310.748L1792.68 313.34C1790.96 311.54 1790.09 310.622 1790.05 310.586C1790.03 310.55 1789.99 310.514 1789.94 310.478C1789.89 310.442 1789.86 310.406 1789.83 310.37L1787.12 307.526L1790.1 307.832ZM1784.15 305.996L1786.09 307.868V312.278L1784.15 314.042V305.996ZM1786.22 306.644C1785.8 306.296 1785.38 305.966 1784.96 305.654L1786.22 304.7H1791.15L1792.41 305.654L1791.15 306.644H1786.22ZM1784.67 296.546H1792.7L1790.95 298.49H1786.5L1784.67 296.546ZM1784.09 305.366V297.32L1786.04 299.066V303.53L1784.09 305.366ZM1793.27 297.32V305.366L1791.33 303.62V299.174L1793.27 297.32ZM1787.12 307.526H1789.82C1790.21 307.946 1790.78 308.546 1791.51 309.326C1792.25 310.094 1792.71 310.568 1792.88 310.748L1792.68 313.34C1790.96 311.54 1790.09 310.622 1790.05 310.586C1790.03 310.55 1789.99 310.514 1789.94 310.478C1789.89 310.442 1789.86 310.406 1789.83 310.37L1787.12 307.526Z"
              v-bind:fill="theme.minor"
            />
          </g>
        </g>
        <g id="remove-clock-btn">
          <g filter="url(#filter15_d)">
            <rect
              x="1578"
              y="237"
              width="255"
              height="48"
              v-bind:fill="theme.base"
            />
            <rect
              x="1580.5"
              y="239.5"
              width="250"
              height="43"
              v-bind:stroke="theme.major"
              stroke-width="5"
            />
          </g>
          <g filter="url(#filter16_d)">
            <path
              d="M1629.73 263.3V267.278L1627.79 269.042V260.996L1629.73 263.3ZM1633.74 262.832L1636.52 265.748L1636.32 268.34C1634.6 266.54 1633.73 265.622 1633.69 265.586C1633.67 265.55 1633.63 265.514 1633.58 265.478C1633.53 265.442 1633.5 265.406 1633.47 265.37L1630.76 262.526L1633.74 262.832ZM1627.79 260.996L1629.73 262.868V267.278L1627.79 269.042V260.996ZM1629.86 261.644C1629.44 261.296 1629.02 260.966 1628.6 260.654L1629.86 259.7H1634.79L1636.05 260.654L1634.79 261.644H1629.86ZM1628.31 251.546H1636.34L1634.59 253.49H1630.14L1628.31 251.546ZM1627.73 260.366V252.32L1629.68 254.066V258.53L1627.73 260.366ZM1636.91 252.32V260.366L1634.97 258.62V254.174L1636.91 252.32ZM1630.76 262.526H1633.46C1633.85 262.946 1634.42 263.546 1635.15 264.326C1635.89 265.094 1636.35 265.568 1636.52 265.748L1636.32 268.34C1634.6 266.54 1633.73 265.622 1633.69 265.586C1633.67 265.55 1633.63 265.514 1633.58 265.478C1633.53 265.442 1633.5 265.406 1633.47 265.37L1630.76 262.526ZM1642.97 269.834L1644.83 267.89H1649.27L1651.04 269.834H1642.97ZM1642.45 260.996L1644.38 262.868V267.278L1642.45 269.042V260.996ZM1644.52 261.644C1644.08 261.296 1643.66 260.966 1643.26 260.654L1644.52 259.7H1649.44L1650.7 260.654L1649.44 261.644H1644.52ZM1642.96 251.546H1650.98L1649.24 253.49H1644.79L1642.96 251.546ZM1642.4 260.366V252.32L1644.32 254.066V258.53L1642.4 260.366ZM1655.73 260.996L1657.68 262.868V267.278L1655.73 269.042V260.996ZM1666.69 269.042L1664.75 267.188V262.76L1666.69 260.996V269.042ZM1660.81 256.388L1660.9 257.18L1659.33 257.036L1655.71 253.67L1655.46 252.122L1657.03 252.266L1660.65 255.596L1660.81 256.388ZM1655.7 260.366V254.48L1657.64 256.244V258.53L1655.7 260.366ZM1666.66 254.48V260.366L1664.71 258.62V256.334L1666.66 254.48ZM1661.42 256.388L1661.58 255.596L1665.2 252.266L1666.77 252.122L1666.51 253.67L1662.9 257.036L1661.33 257.18L1661.42 256.388ZM1671.5 269.834L1673.35 267.89H1677.8L1679.54 269.834H1671.5ZM1670.96 260.996L1672.9 262.868V267.278L1670.96 269.042V260.996ZM1680.12 269.042L1678.17 267.188V262.76L1680.12 260.996V269.042ZM1671.48 251.546H1679.52L1677.74 253.49H1673.33L1671.48 251.546ZM1670.9 260.366V252.32L1672.85 254.066V258.53L1670.9 260.366ZM1680.06 252.32V260.366L1678.12 258.62V254.174L1680.06 252.32ZM1696.96 256.352L1690.77 268.592V264.02L1696.96 251.834V256.352ZM1682.85 256.352V251.834L1689.04 264.02V268.592L1682.85 256.352ZM1700.56 269.834L1702.41 267.89H1706.86L1708.62 269.834H1700.56ZM1700.04 260.996L1701.96 262.868V267.278L1700.04 269.042V260.996ZM1702.11 261.644C1701.66 261.296 1701.24 260.966 1700.85 260.654L1702.11 259.7H1707.02L1708.28 260.654L1707.02 261.644H1702.11ZM1700.54 251.546H1708.57L1706.82 253.49H1702.38L1700.54 251.546ZM1699.98 260.366V252.32L1701.91 254.066V258.53L1699.98 260.366ZM1729.35 269.834L1731.21 267.89H1735.65L1737.42 269.834H1729.35ZM1728.83 260.996L1730.76 262.868V267.278L1728.83 269.042V260.996ZM1729.33 251.546H1737.36L1735.62 253.49H1731.17L1729.33 251.546ZM1728.78 260.366V252.32L1730.7 254.066V258.53L1728.78 260.366ZM1743.75 269.834L1745.6 267.89H1750.05L1751.81 269.834H1743.75ZM1743.23 260.996L1745.15 262.868V267.278L1743.23 269.042V260.996ZM1743.17 260.366V252.32L1745.1 254.066V258.53L1743.17 260.366ZM1757.88 269.834L1759.73 267.89H1764.18L1765.92 269.834H1757.88ZM1757.34 260.996L1759.28 262.868V267.278L1757.34 269.042V260.996ZM1766.5 269.042L1764.55 267.188V262.76L1766.5 260.996V269.042ZM1757.86 251.546H1765.9L1764.12 253.49H1759.71L1757.86 251.546ZM1757.28 260.366V252.32L1759.23 254.066V258.53L1757.28 260.366ZM1766.44 252.32V260.366L1764.5 258.62V254.174L1766.44 252.32ZM1772.54 269.834L1774.4 267.89H1778.84L1780.61 269.834H1772.54ZM1772.02 260.996L1773.95 262.868V267.278L1772.02 269.042V260.996ZM1772.52 251.546H1780.55L1778.81 253.49H1774.36L1772.52 251.546ZM1771.97 260.366V252.32L1773.89 254.066V258.53L1771.97 260.366ZM1788.25 263.3V267.278L1786.33 269.042V260.996L1788.25 263.3ZM1792.01 265.37C1792.03 265.382 1792.06 265.412 1792.1 265.46C1792.16 265.508 1792.21 265.55 1792.23 265.586C1792.23 265.598 1792.24 265.604 1792.25 265.604L1792.27 265.64L1794.89 268.34L1792.01 265.37ZM1792.01 255.956C1792.03 255.944 1792.06 255.914 1792.1 255.866C1792.16 255.818 1792.21 255.776 1792.23 255.74L1792.25 255.722C1792.26 255.71 1792.27 255.698 1792.27 255.686L1794.89 252.986L1792.01 255.956ZM1786.33 260.996L1788.25 262.868V267.278L1786.33 269.042V260.996ZM1788.4 261.644C1787.96 261.296 1787.56 260.966 1787.17 260.654L1788.4 259.7H1788.49L1789.73 260.654L1788.49 261.644H1788.4ZM1786.29 260.366V252.32L1788.22 254.066V258.53L1786.29 260.366ZM1789.3 262.526H1791.98C1792.39 262.934 1792.95 263.522 1793.67 264.29C1794.4 265.058 1794.86 265.544 1795.06 265.748L1794.89 268.34L1792.27 265.64L1792.25 265.622C1792.24 265.61 1792.23 265.598 1792.23 265.586L1792.01 265.37L1789.3 262.526ZM1789.3 258.8L1792.01 255.956C1792.03 255.944 1792.06 255.914 1792.1 255.866C1792.16 255.818 1792.21 255.776 1792.23 255.74L1792.25 255.722C1792.26 255.71 1792.27 255.698 1792.27 255.686L1794.89 252.986L1795.06 255.578C1794.86 255.782 1794.4 256.268 1793.67 257.036C1792.95 257.804 1792.39 258.392 1791.98 258.8H1789.3Z"
              v-bind:fill="theme.minor"
            />
          </g>
        </g>
        <g id="add-clock-btn">
          <g filter="url(#filter17_d)">
            <rect
              x="1578"
              y="195"
              width="255"
              height="48"
              v-bind:fill="theme.base"
            />
            <rect
              x="1580.5"
              y="197.5"
              width="250"
              height="43"
              v-bind:stroke="theme.major"
              stroke-width="5"
            />
          </g>
          <g filter="url(#filter18_d)">
            <path
              d="M1647.36 217.996L1649.31 219.868V224.278L1647.36 226.042V217.996ZM1656.52 226.042L1654.58 224.188V219.76L1656.52 217.996V226.042ZM1649.45 218.644C1649.03 218.308 1648.6 217.978 1648.17 217.654L1649.45 216.7H1654.36L1655.62 217.654L1654.36 218.644H1649.45ZM1647.88 208.546H1655.93L1654.15 210.49H1649.74L1647.88 208.546ZM1647.31 217.366V209.32L1649.25 211.066V215.53L1647.31 217.366ZM1656.47 209.32V217.366L1654.53 215.62V211.174L1656.47 209.32ZM1662.3 226.834L1664.15 224.89H1668.6L1670.34 226.834H1662.3ZM1661.76 217.996L1663.7 219.868V224.278L1661.76 226.042V217.996ZM1670.92 226.042L1668.98 224.188V219.76L1670.92 217.996V226.042ZM1662.28 208.546H1670.33L1668.54 210.49H1664.13L1662.28 208.546ZM1661.7 217.366V209.32L1663.65 211.066V215.53L1661.7 217.366ZM1670.87 209.32V217.366L1668.92 215.62V211.174L1670.87 209.32ZM1676.69 226.834L1678.55 224.89H1682.99L1684.74 226.834H1676.69ZM1676.15 217.996L1678.1 219.868V224.278L1676.15 226.042V217.996ZM1685.32 226.042L1683.37 224.188V219.76L1685.32 217.996V226.042ZM1676.68 208.546H1684.72L1682.94 210.49H1678.53L1676.68 208.546ZM1676.1 217.366V209.32L1678.04 211.066V215.53L1676.1 217.366ZM1685.26 209.32V217.366L1683.32 215.62V211.174L1685.26 209.32ZM1705.76 226.834L1707.61 224.89H1712.06L1713.82 226.834H1705.76ZM1705.24 217.996L1707.16 219.868V224.278L1705.24 226.042V217.996ZM1705.74 208.546H1713.77L1712.02 210.49H1707.58L1705.74 208.546ZM1705.18 217.366V209.32L1707.11 211.066V215.53L1705.18 217.366ZM1720.15 226.834L1722.01 224.89H1726.45L1728.22 226.834H1720.15ZM1719.63 217.996L1721.56 219.868V224.278L1719.63 226.042V217.996ZM1719.58 217.366V209.32L1721.5 211.066V215.53L1719.58 217.366ZM1734.28 226.834L1736.13 224.89H1740.58L1742.33 226.834H1734.28ZM1733.74 217.996L1735.68 219.868V224.278L1733.74 226.042V217.996ZM1742.9 226.042L1740.96 224.188V219.76L1742.9 217.996V226.042ZM1734.26 208.546H1742.31L1740.53 210.49H1736.12L1734.26 208.546ZM1733.69 217.366V209.32L1735.63 211.066V215.53L1733.69 217.366ZM1742.85 209.32V217.366L1740.9 215.62V211.174L1742.85 209.32ZM1748.95 226.834L1750.8 224.89H1755.25L1757.01 226.834H1748.95ZM1748.43 217.996L1750.35 219.868V224.278L1748.43 226.042V217.996ZM1748.93 208.546H1756.96L1755.21 210.49H1750.77L1748.93 208.546ZM1748.37 217.366V209.32L1750.3 211.066V215.53L1748.37 217.366ZM1764.66 220.3V224.278L1762.73 226.042V217.996L1764.66 220.3ZM1768.42 222.37C1768.43 222.382 1768.46 222.412 1768.51 222.46C1768.57 222.508 1768.61 222.55 1768.64 222.586C1768.64 222.598 1768.64 222.604 1768.65 222.604L1768.67 222.64L1771.3 225.34L1768.42 222.37ZM1768.42 212.956C1768.43 212.944 1768.46 212.914 1768.51 212.866C1768.57 212.818 1768.61 212.776 1768.64 212.74L1768.65 212.722C1768.67 212.71 1768.67 212.698 1768.67 212.686L1771.3 209.986L1768.42 212.956ZM1762.73 217.996L1764.66 219.868V224.278L1762.73 226.042V217.996ZM1764.8 218.644C1764.37 218.296 1763.96 217.966 1763.58 217.654L1764.8 216.7H1764.89L1766.13 217.654L1764.89 218.644H1764.8ZM1762.7 217.366V209.32L1764.62 211.066V215.53L1762.7 217.366ZM1765.7 219.526H1768.38C1768.79 219.934 1769.36 220.522 1770.08 221.29C1770.81 222.058 1771.27 222.544 1771.46 222.748L1771.3 225.34L1768.67 222.64L1768.65 222.622C1768.64 222.61 1768.64 222.598 1768.64 222.586L1768.42 222.37L1765.7 219.526ZM1765.7 215.8L1768.42 212.956C1768.43 212.944 1768.46 212.914 1768.51 212.866C1768.57 212.818 1768.61 212.776 1768.64 212.74L1768.65 212.722C1768.67 212.71 1768.67 212.698 1768.67 212.686L1771.3 209.986L1771.46 212.578C1771.27 212.782 1770.81 213.268 1770.08 214.036C1769.36 214.804 1768.79 215.392 1768.38 215.8H1765.7Z"
              v-bind:fill="theme.minor"
            />
          </g>
        </g>
        <g id="restart-btn" @click="onClickRestart">
          <g filter="url(#filter19_d)">
            <rect
              x="1578"
              y="153"
              width="255"
              height="48"
              v-bind:fill="theme.base"
            />
            <rect
              x="1580.5"
              y="155.5"
              width="250"
              height="43"
              v-bind:stroke="theme.major"
              stroke-width="5"
            />
          </g>
          <g filter="url(#filter20_d)">
            <path
              d="M1663.72 178.3V182.278L1661.78 184.042V175.996L1663.72 178.3ZM1667.73 177.832L1670.51 180.748L1670.31 183.34C1668.59 181.54 1667.72 180.622 1667.68 180.586C1667.66 180.55 1667.62 180.514 1667.57 180.478C1667.52 180.442 1667.49 180.406 1667.46 180.37L1664.75 177.526L1667.73 177.832ZM1661.78 175.996L1663.72 177.868V182.278L1661.78 184.042V175.996ZM1663.85 176.644C1663.43 176.296 1663.01 175.966 1662.59 175.654L1663.85 174.7H1668.78L1670.04 175.654L1668.78 176.644H1663.85ZM1662.3 166.546H1670.33L1668.58 168.49H1664.13L1662.3 166.546ZM1661.72 175.366V167.32L1663.67 169.066V173.53L1661.72 175.366ZM1670.9 167.32V175.366L1668.96 173.62V169.174L1670.9 167.32ZM1664.75 177.526H1667.45C1667.84 177.946 1668.41 178.546 1669.14 179.326C1669.88 180.094 1670.34 180.568 1670.51 180.748L1670.31 183.34C1668.59 181.54 1667.72 180.622 1667.68 180.586C1667.66 180.55 1667.62 180.514 1667.57 180.478C1667.52 180.442 1667.49 180.406 1667.46 180.37L1664.75 177.526ZM1676.96 184.834L1678.82 182.89H1683.26L1685.03 184.834H1676.96ZM1676.44 175.996L1678.37 177.868V182.278L1676.44 184.042V175.996ZM1678.51 176.644C1678.07 176.296 1677.65 175.966 1677.25 175.654L1678.51 174.7H1683.43L1684.69 175.654L1683.43 176.644H1678.51ZM1676.95 166.546H1684.97L1683.23 168.49H1678.78L1676.95 166.546ZM1676.39 175.366V167.32L1678.31 169.066V173.53L1676.39 175.366ZM1691.09 184.834L1692.95 182.89H1697.39L1699.14 184.834H1691.09ZM1699.71 184.042L1697.77 182.188V177.76L1699.71 175.996V184.042ZM1692.64 176.644C1692.22 176.308 1691.79 175.978 1691.36 175.654L1692.64 174.7H1697.55L1698.81 175.654L1697.55 176.644H1692.64ZM1691.07 166.546H1699.12L1697.34 168.49H1692.93L1691.07 166.546ZM1690.5 175.366V167.32L1692.44 169.066V173.53L1690.5 175.366ZM1710.49 184.042L1708.55 182.188V177.76L1710.49 175.996V184.042ZM1703.98 168.166C1703.56 167.83 1703.14 167.512 1702.72 167.212L1703.98 166.24H1715.03L1716.29 167.212L1715.03 168.166H1710.44V175.366L1708.49 173.62V169.174L1709.56 168.166H1703.98ZM1719.34 175.996L1721.29 177.868V182.278L1719.34 184.042V175.996ZM1728.51 184.042L1726.56 182.188V177.76L1728.51 175.996V184.042ZM1721.43 176.644C1721.01 176.308 1720.59 175.978 1720.15 175.654L1721.43 174.7H1726.35L1727.61 175.654L1726.35 176.644H1721.43ZM1719.87 166.546H1727.91L1726.13 168.49H1721.72L1719.87 166.546ZM1719.29 175.366V167.32L1721.23 169.066V173.53L1719.29 175.366ZM1728.45 167.32V175.366L1726.51 173.62V169.174L1728.45 167.32ZM1735.7 178.3V182.278L1733.76 184.042V175.996L1735.7 178.3ZM1739.72 177.832L1742.49 180.748L1742.29 183.34C1740.57 181.54 1739.7 180.622 1739.66 180.586C1739.64 180.55 1739.6 180.514 1739.55 180.478C1739.51 180.442 1739.47 180.406 1739.45 180.37L1736.73 177.526L1739.72 177.832ZM1733.76 175.996L1735.7 177.868V182.278L1733.76 184.042V175.996ZM1735.83 176.644C1735.41 176.296 1734.99 175.966 1734.57 175.654L1735.83 174.7H1740.76L1742.02 175.654L1740.76 176.644H1735.83ZM1734.28 166.546H1742.31L1740.56 168.49H1736.12L1734.28 166.546ZM1733.7 175.366V167.32L1735.65 169.066V173.53L1733.7 175.366ZM1742.88 167.32V175.366L1740.94 173.62V169.174L1742.88 167.32ZM1736.73 177.526H1739.43C1739.82 177.946 1740.39 178.546 1741.12 179.326C1741.86 180.094 1742.32 180.568 1742.49 180.748L1742.29 183.34C1740.57 181.54 1739.7 180.622 1739.66 180.586C1739.64 180.55 1739.6 180.514 1739.55 180.478C1739.51 180.442 1739.47 180.406 1739.45 180.37L1736.73 177.526ZM1753.68 184.042L1751.74 182.188V177.76L1753.68 175.996V184.042ZM1747.17 168.166C1746.75 167.83 1746.33 167.512 1745.91 167.212L1747.17 166.24H1758.22L1759.48 167.212L1758.22 168.166H1753.63V175.366L1751.68 173.62V169.174L1752.75 168.166H1747.17Z"
              v-bind:fill="theme.minor"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="1601"
          y="75"
          width="250"
          height="84"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="5" dy="5" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d"
          x="1644.67"
          y="93.32"
          width="154.655"
          height="32.792"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d"
          x="685"
          y="879"
          width="558"
          height="135"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="5" dy="5" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d"
          x="837.247"
          y="908.52"
          width="253.262"
          height="74.112"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d"
          x="177"
          y="269"
          width="1575"
          height="539"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="5" dy="5" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d"
          x="1237"
          y="334"
          width="409"
          height="409"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="5" dy="5" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d"
          x="760"
          y="334"
          width="409"
          height="409"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="5" dy="5" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d"
          x="283"
          y="334"
          width="409"
          height="409"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="5" dy="5" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter8_d"
          x="1288.27"
          y="468.912"
          width="296.77"
          height="105.536"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter9_d"
          x="811.268"
          y="468.912"
          width="296.77"
          height="105.536"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter10_d"
          x="334.268"
          y="468.912"
          width="296.77"
          height="105.536"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter11_d"
          x="1578"
          y="327"
          width="264"
          height="57"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="5" dy="5" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter12_d"
          x="1665.19"
          y="336.384"
          width="88.6224"
          height="26.45"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter13_d"
          x="1578"
          y="282"
          width="264"
          height="57"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="5" dy="5" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter14_d"
          x="1622"
          y="293.384"
          width="175.271"
          height="26.45"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter15_d"
          x="1578"
          y="237"
          width="264"
          height="57"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="5" dy="5" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter16_d"
          x="1623.73"
          y="248.546"
          width="175.325"
          height="26.288"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter17_d"
          x="1578"
          y="195"
          width="264"
          height="57"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="5" dy="5" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter18_d"
          x="1643.31"
          y="205.546"
          width="132.154"
          height="26.288"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter19_d"
          x="1578"
          y="153"
          width="264"
          height="57"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="5" dy="5" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter20_d"
          x="1657.72"
          y="163.24"
          width="105.755"
          height="26.594"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </div>
</template>

<script lang="ts">
import { Vue } from 'vue-class-component';
import * as Theme from './presets';
import { Timer } from './timer';
import { START_PATH, STOP_PATH } from './main-button-path';
import { ClockModel } from './models';

export default class Clock extends Vue implements ClockModel {
  readonly queue = Timer.createTripleTimer(this);
  readonly leftTimer = this.queue[0];
  readonly middleTimer = this.queue[1];
  readonly rightTimer = this.queue[2];
  theme = Theme.ThemePicker.pick(Theme.lavender);
  settingsClicked = false;
  isRunning = false;
  mainBtn = START_PATH;
  current = 0;

  /**
   * When timer is up, this function needs to be invoked.
   */
  forcePause(): void {
    this.setStatusToPause();
    this.next();
  }

  private get currentTimer(): Timer {
    return this.queue[this.current];
  }

  private resetEveryTimer(): void {
    this.queue.forEach((timer) => timer.reset());
  }

  private isAllUp(): boolean {
    return this.queue.every((timer) => timer.isUp);
  }

  private next(): void {
    if (this.isAllUp()) {
      this.resetCurrent();
      return;
    }
    this.current = ++this.current % this.queue.length;
    if (this.currentTimer.isUp) {
      this.next();
    }
  }

  private resetCurrent(): void {
    if (this.currentTimer !== this.leftTimer) {
      this.current = 0;
    }
  }

  private startTimer(): void {
    if (this.isAllUp()) {
      this.pauseTimer();
      this.resetEveryTimer();
    }
    this.currentTimer.start();
  }

  private pauseTimer(): void {
    this.currentTimer.pause();
    this.next();
  }

  private setStatusToPause(): void {
    this.mainBtn = START_PATH;
    this.isRunning = false;
  }

  private setStatusToRunning(): void {
    this.mainBtn = STOP_PATH;
    this.isRunning = true;
  }

  onClickColorChange(): void {
    this.theme = Theme.ThemePicker.pickOne();
  }

  onClick(): void {
    if (this.isRunning) {
      this.setStatusToPause();
      this.pauseTimer();
    } else {
      this.setStatusToRunning();
      this.startTimer();
    }
  }

  onClickRestart(): void {
    this.setStatusToPause();
    this.pauseTimer();
    this.resetCurrent();
    this.resetEveryTimer();
  }

  onClickSettings(): void {
    this.settingsClicked = !this.settingsClicked;
  }
}
</script>
